var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "category-list-modal",
      attrs: {
        "close-on-click-modal": false,
        visible: _vm.diaVisible,
        title: "",
        width: "550px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.diaVisible = $event
        },
        close: function ($event) {
          return _vm.$emit("update:visible", false)
        },
      },
    },
    [
      _c("div", { attrs: { slot: "title" }, slot: "title" }, [
        _vm._v(
          " " +
            _vm._s(
              _vm.params.type == "add"
                ? _vm.$t("product-manager::category::add_dialog")
                : _vm.params.type == "next"
                ? _vm.$t("product-manager::category::add_child_dialog")
                : _vm.$t("product-manager::category::edit_dialog")
            ) +
            " "
        ),
      ]),
      _c(
        "el-form",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.cateloading,
              expression: "cateloading",
            },
          ],
          ref: "form",
          staticClass: "cate-body",
          attrs: {
            model: _vm.params,
            rules: _vm.rules,
            "label-width": "100px",
          },
          nativeOn: {
            submit: function ($event) {
              $event.preventDefault()
            },
          },
        },
        [
          ((_vm.params.type == "edit" &&
            _vm.params.row &&
            _vm.params.row.parentId !== 0) ||
            _vm.params.type === "add") &&
          _vm.visible
            ? _c(
                "el-form-item",
                {
                  attrs: {
                    label:
                      _vm.$t("product-manager::category::form_father") + "：",
                    prop: "category",
                  },
                },
                [
                  _c("el-cascader", {
                    ref: "casc",
                    staticClass: "input-item",
                    attrs: {
                      "append-to-body": false,
                      disabled:
                        _vm.params.type !== "add" &&
                        _vm.params.row &&
                        _vm.params.row.childrens &&
                        _vm.params.row.childrens.length !== 0,
                      options: _vm.tableData,
                      props: _vm.props,
                      clearable: "",
                      filterable: "",
                    },
                    on: { change: _vm.handleCase },
                    model: {
                      value: _vm.params.category,
                      callback: function ($$v) {
                        _vm.$set(_vm.params, "category", $$v)
                      },
                      expression: "params.category",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.params.type == "next"
            ? _c(
                "el-form-item",
                {
                  attrs: {
                    label:
                      _vm.$t("product-manager::category::form_father") + "：",
                  },
                },
                [
                  _c("span", [
                    _vm._v(_vm._s(_vm.parentCate ? _vm.parentCate : "/")),
                  ]),
                ]
              )
            : _vm._e(),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("product-manager::category::form_name") + "：",
                prop: "name",
              },
            },
            [
              _c("el-input", {
                staticClass: "input-item",
                model: {
                  value: _vm.params.name,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.params,
                      "name",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "params.name",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  return _vm.$emit("update:visible", false)
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("system::common::btn::cancel")))]
          ),
          _c(
            "el-button",
            {
              attrs: { loading: _vm.loading, type: "primary" },
              on: { click: _vm.onSave },
            },
            [_vm._v(_vm._s(_vm.$t("system::common::btn::save")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }